export default __webpack_public_path__ + "static/Group 188-e53cf02d64a80d07fc6c2ae7d69746ec.png";